<template>
    <LangSwitch :lang="appStore.locale" :lang-options="localeOptions" :tooltip-content="$t('icon.lang')"
        @change-lang="changeLocale" />
</template>

<script setup lang="ts">
import { LangSwitch } from '@yammii/materials';
import { useAppStore } from '@/store/modules/app';

defineOptions({ name: 'LangSwitchWrapper' });

const appStore = useAppStore();

const { localeOptions, changeLocale } = appStore;
</script>

<style lang="scss" scoped></style>